<template>
  <div v-if="$userprofile">
    <div v-if="!hide">
      <!-- Current Plan -->
      <span>
        <!-- Quota information -->
        <span
          v-if="$userprofile.content_creator_plan_booking"
          class="mb-2"
          :class="{
            'warning--text':
              $userprofile.content_creator_plan_booking.quota_depleted,
          }"
        >
          <span
            v-if="
              $userprofile &&
                $userprofile.content_creator_plan_booking &&
                $userprofile.content_creator_plan_booking.plan.is_rate_limited
            "
          >
            {{
              $userprofile.content_creator_plan_booking.quota_current_used
            }}/{{
              $userprofile.content_creator_plan_booking.plan
                .production_limit_per_month
            }}
          </span>
          <!-- <span v-else> {{ $t('toUnlimited') }}. </span> -->
          <span v-if="$userprofile.content_creator_plan_booking.quota_depleted">
            {{ $t('tvtemplatesProduceTvspotQuotaDepleted_1') }}.
            {{ $t('tvtemplatesProduceTvspotQuotaDepleted_2') }}.
          </span>
        </span>
        <!-- Link to Plans page -->
        <router-link
          v-if="
            !$userprofile.content_creator_plan_booking
              .not_billed_and_managed_by_myshopradio
          "
          :to="{name: 'contentcreatorplans'}"
          data-cy="contentcreator-status-hint-plans-link"
        >
          <span
            v-if="
              canDoTestBooking &&
                !$userprofile.content_creator_plan_booking.test_has_expired
            "
          >
            {{ $t('contentCreatorCurrentPlanFreeDefaultUpgradeNow') }}</span><span
            v-else-if="
              canDoTestBooking &&
                $userprofile.content_creator_plan_booking.test_has_expired
            "
          >
            {{ $t('contentCreatorTestAgainOrBook') }}</span><span v-else>{{
            $t('contentCreatorGoToPlansPage')
          }}</span></router-link>

        <!-- Waiting for admin approval of booking request -->
        <span
          v-if="bookingRequests.length > 0"
          class="warning--text"
        >
          ({{ $t('contentCreatorBookingRequestActiveManagedTitle') }})
        </span>
        <!-- Testphase info -->
        <span
          v-else-if="
            $userprofile.content_creator_plan_booking &&
              $userprofile.content_creator_plan_booking.is_test &&
              $userprofile.content_creator_plan_booking.test_started_at &&
              $userprofile.content_creator_plan_booking.test_expires_at
          "
          class="nowrap info--text"
        >
          <!-- Will expire in a few days -->
          <span
            v-if="
              $userprofile.content_creator_plan_booking.test_expires_in_days > 1
            "
          >
            ({{
              $t('contentCreatorPlanTestExpiresInDays').replace(
                '{days}',
                $userprofile.content_creator_plan_booking.test_expires_in_days
              )
            }})
          </span>
          <!-- Will expire tomorrow-->
          <span
            v-if="
              $userprofile.content_creator_plan_booking.test_expires_in_days ==
                1
            "
          >
            ({{ $t('contentCreatorPlanTestExpiresTomorrow') }})
          </span>
          <!-- Will expire today-->
          <span
            v-if="
              $userprofile.content_creator_plan_booking.test_expires_in_days ==
                0
            "
          >
            ({{ $t('contentCreatorPlanTestExpiresToday') }})
          </span>
          <!-- Already expired -->
          <span
            v-if="
              $userprofile.content_creator_plan_booking.test_has_expired &&
                !canDoTestBooking
            "
            class="warning--text"
          >
            ({{ $t('contentCreatorPlanTestExpired') }})
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    hideWhenPaidBookingExists: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      bookingRequests: (state) => state.common.contentcreatorBookingRequests,
      canDoTestBooking: (state) => state.common.contentcreatorCanDoTestBooking,
    }),
    hide() {
      if (!this.hideWhenPaidBookingExists) {
        return false;
      }
      return (
        this.$userprofile &&
        this.$userprofile.content_creator_plan_booking &&
        !this.$userprofile.content_creator_plan_booking.is_test
      );
    },
  },
  created() {
    this.$store.dispatch('RETRIEVE_CONTENTCREATOR_CAN_DO_TEST_BOOKING');
    this.$store.dispatch('LIST_CONTENTCREATOR_BOOKING_REQUESTS');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ContentCreatorPlanStatusHint.vue